export type StorageKey = 'last-visited-room' | 'download-popup-seen' | 'download-banner-seen'

export class LocalStorage {

  static get(key: StorageKey | string): string | null {
    try {
      if (localStorage?.length > 0) {
        return localStorage.getItem(key);
      }
    } catch (error) {
      alert(error);
    }
    return null;
  }


  static set(key: StorageKey | string, value: string) {
    try {
      localStorage?.setItem(key, value);
    } catch (error) {
      alert(error);
    }
  }

  static clear() {
    try {
      localStorage?.clear();
    } catch (error) {
      alert(error);
    }
  }

}